// extracted by mini-css-extract-plugin
export default {"gamesCell":"gamesCell-yeb5ykyM"};